<template>
  <div id="upload-controller" :class="{ dialog: isDialog }">
    <div class="container">
      <!--UPLOAD-->
      <form enctype="multipart/form-data" novalidate>
        <div class="dropbox">
          <input
            type="file"
            multiple
            :name="uploadFieldName"
            :disabled="isSaving"
            :value="fileUpload"
            @change="save"
            accept="image/*"
            id="input-file"
          />
          <p>
            <span>{{ $t("DRAG_DROP_PHOTOS_HERE") }}</span>
            <br />
            {{ $t("OR") }}
            <br />
            <label id="btn-upload" for="input-file">
              {{
              $t("SELECT_PHOTOS_TO_UPLOAD")
              }}
            </label>
            <br />
            {{ $t("MAXIMUM_CAPACITY") }} 5MB
          </p>
        </div>
      </form>
    </div>
    <div v-if="isSaving || isFailed">
      <label v-if="currentLoading">{{ $t("LOADING") }} ({{ currentLoading }} {{ $t("IMAGES") }})</label>
      <v-progress-linear height="8" :value="uploadedPercent" rounded></v-progress-linear>
    </div>
  </div>
</template>

<script>
// swap as you need
//import { upload } from "@/_services/UploadFile/file-upload.fake.service"; // fake service
import { service } from "@/_services/UploadFile/upload-file.service"; // real service
import { MAX_SIZE_IMAGE_UPLOAD } from "@/_helpers/constant";
import { _alert } from "@/_helpers/function";
import { reject } from "q";

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;
export default {
  props: {
    isDialog: Boolean
  },
  data() {
    return {
      uploadError: null,
      currentStatus: 0,
      uploadFieldName: "file",
      fileUpload: "",
      errorMessage: null,
      uploadedPercent: 0,
      currentLoading: null
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  mounted() {
    this.resetStatus();
    document
      .getElementById("upload-controller")
      .addEventListener("click", function(event) {
        let target = document
          .getElementById("btn-upload")
          .getBoundingClientRect();
        if (
          target.right < event.clientX ||
          event.clientX < target.left ||
          event.clientY < target.top ||
          target.bottom < event.clientY
        ) {
          event.preventDefault();
        }
      });
  },
  methods: {
    async save() {
      let justUploaded = [];
      let store = this.$store;
      // upload data to the server
      this.currentStatus = STATUS_SAVING;

      const fileInput = document.querySelector("#input-file");
      this.updateProcess({ current: 0, total: fileInput.files.length });
      let formData = new FormData();
      let formatImage = ["image/jpg", "image/jpeg", "image/png"];
      let listFile = [...fileInput.files];
      let img;
      let file;
      let failCount = 0;
      let _URL = window.URL || window.webkitURL;
      listFile.forEach(x => {
        if (!formatImage.includes(x.type)) {
          listFile.splice(listFile.indexOf(x), 1);
          this.$store.commit("alert/display", {
            message: this.$t("INVALID_IMAGE_FORMAT"),
            error: true,
            success: false
          });
          failCount++;
          this.currentStatus = STATUS_FAILED;
          return false;
        }
        if (x.size > MAX_SIZE_IMAGE_UPLOAD) {
          listFile.splice(listFile.indexOf(x), 1);
          this.$store.commit("alert/display", {
            message: this.$t("IMAGE_CAPACITY_NOT_BIGGER_THAN") + " 5MB",
            error: true,
            success: false
          });
          failCount++;
          this.currentStatus = STATUS_FAILED;
        }
      });
      if (!failCount) this.currentStatus = STATUS_SAVING;
      let listRemove = [];
      for (const file of listFile) {
        let src = _URL.createObjectURL(file);
        let dimension = await this.getImage(src);
        if (dimension.width < 200 || dimension.height < 200) {
          listRemove.push(file);
          failCount++;
          store.commit("alert/display", {
            message: this.$t("IMAGE_SIZE_NOT_BIGGER_THAN") + ": 200 x 200px",
            error: true,
            success: false
          });
        }
      }
      listRemove.forEach(x => {
        listFile.splice(listFile.indexOf(x), 1);
        this.currentStatus = STATUS_FAILED;
      });

      let promises = listFile.map(x => {
        formData = new FormData();
        formData.append("file", x);
        return service.uploadImage(formData);
      });
      let index = -1;
      for (const promise of promises) {
        await promise
          .then(x => {
            if (x.responseCode == 1) {
              _alert(x, this.$t("FAIL"), false);
              return false;
            }
            index++;
            _alert(x, this.$t("UPLOAD_SUCCESS"), false);
            justUploaded.push(x.data);
            this.updateProcess({
              current: index + 1,
              total: promises.length + failCount
            });
          })
          .catch(err => {
            this.uploadError = err.response;
            this.currentStatus = STATUS_FAILED;
          });
      }
      this.currentStatus = STATUS_SUCCESS;
      this.$store.commit("hotelImage/storedListJustUploaded", justUploaded);
      this.currentLoading = "";
      this.uploadedPercent = 0;
      this.$emit("reload");
    },
    updateProcess(process) {
      this.currentLoading = process
        ? `${process.current}/${process.total}`
        : null;
      this.uploadedPercent = (process.current / process.total) * 100;
    },
    resetStatus() {
      this.currentStatus = STATUS_INITIAL;
    },
    getImage(src) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () => resolve({ width: img.width, height: img.height });
        img.onerror = reject;
        img.src = src;
      });
    }
  }
};
</script>
